"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadFile = void 0;

var _fileSaver = require("file-saver");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var downloadFile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var contents, _ref$type, type, _ref$encoding, encoding, _ref$filename, filename, blob;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contents = _ref.contents, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text/plan' : _ref$type, _ref$encoding = _ref.encoding, encoding = _ref$encoding === void 0 ? 'utf-8' : _ref$encoding, _ref$filename = _ref.filename, filename = _ref$filename === void 0 ? 'Unnamed file' : _ref$filename;
            blob = new Blob([contents], {
              type: "".concat(type, ";charset=").concat(encoding)
            });
            return _context.abrupt("return", (0, _fileSaver.saveAs)(blob, filename));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function downloadFile(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.downloadFile = downloadFile;